// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pJMb","comment":"styles_comment__ZFrNo"};